import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '@carvana/showroom-grid';
import VehicleFrontIcon from '../images/icons/vehicle-front.svg';
import MoneyIcon from '../images/icons/money.svg';
import TradeInIcon from '../images/icons/trade-in.svg';
import BankIcon from '../images/icons/bank.svg';
import DeliveryIcon from '../images/icons/delivery.svg';
import CarvanaCertifiedIcon from '../images/icons/carvana-certified.svg';
import GreatDealIcon from '../images/icons/great-deal.svg';
import { Link } from 'gatsby';
import { getMediaQuery } from '@carvana/showroom-theme';

const TopicHeadline = styled.div`
  /* width: 153px; */
  margin-left: 1rem;
  text-decoration: none;
  color: ${(props) => props.theme.color.primary.v600};

  &:hover {
    text-decoration: none;
    color: ${(props) => props.theme.color.primary.v200};
  }
`;

const TopicWrapper = styled(Link)`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  min-height: 90px;
  max-width: 353px;
  background-color: ${(props) => props.theme.color.neutral.v100};
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0.5rem auto;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 1rem;
  border-radius: 3px;

  &:hover {
    text-decoration: none;
    border-color: ${(props) => props.theme.color.primary.v600};
    color: ${(props) => props.theme.color.primary.v200};

    ${TopicHeadline} {
      border-color: ${(props) => props.theme.color.primary.v600};
      color: ${(props) => props.theme.color.primary.v200};

      &:hover {
        color: ${(props) => props.theme.color.primary.v200};
      }
    }
  }
`;

const Topic = ({ headline, Icon, url }) => {
  return (
    <TopicWrapper to={url || '/'}>
      {Icon && <Icon />}
      <TopicHeadline>{headline}</TopicHeadline>
    </TopicWrapper>
  );
};

const Column = styled(Cell).attrs({ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 })`
  padding: 0 1rem;
`;

const TopicHeadlineToIconMap = (topic) =>
  ({
    'trading in & selling': TradeInIcon,
    'purchasing a car': MoneyIcon,
    'about our vehicles': VehicleFrontIcon,
    'payment & financing': BankIcon,
    'payment and financing': BankIcon,
    'pickup & delivery': DeliveryIcon,
    warranty: CarvanaCertifiedIcon,
    'extended coverage & repairs': CarvanaCertifiedIcon,
    'vehicle protection & repairs': CarvanaCertifiedIcon,
    referral: GreatDealIcon,
    'referral program & promotions': GreatDealIcon
  }[topic || 'referral']);

export const Topics = ({ topics }) => {
  return (
    <Grid>
      {topics.map((cat) => {
        return (
          <Column key={cat.node.topic_name}>
            <Topic
              key={Date.now()}
              Icon={TopicHeadlineToIconMap(cat.node.topic_name.toLowerCase())}
              headline={cat.node.topic_name}
              url={`/${cat.node.topic_url}`}
            />
          </Column>
        );
      })}
    </Grid>
  );
};
